module.exports = __webpack_public_path__ + "img/hongbao_guan@3x.ce4610c8.png";